import React, { useState, useEffect } from "react";
import "./Accordion.css";
import "../DashBoard/sliding.css";
import { Card } from "react-bootstrap";
import { Modal, Box } from "@mui/material";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { contentReducer } from "../../Redux/store";
// import { useSelector } from "react-redux";
// import React from 'react'

const ProductAccordion = ({ parentItem, tableupdate }) => {
  //API related selectors
  const token = useSelector((state) => state.AccessTocken.accessTocken);
  //Header for API's
  const options = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  // const[contentPopUpType, setContentPopUpType] = useState([]);
  const { productId, productName, contents, division } = parentItem;
  const { divisionname, business_unit } = division;
  const { buName } = business_unit;
  const [viewContentPopUp, setViewContentPopUp] = useState(false);
  const [contentPopUpType, setContentPopUpType] = useState("");
  const [contentPopUpFormat, setContentPopUpFormat] = useState("");
  const [contentPopUpSrc, setContentPopUpSrc] = useState("");
  const [viewContentPopUpDetails, setViewContentPopUpDetails] = useState([]);

  const [isActive, setIsActive] = useState(false);
  const apiLoad = useSelector((state) => state.sidebar.apiLoad);

  //View content update
  // const bu_viewcontent = useSelector((state) => state.content.bu_viewcontent);
  // const division_viewcontent = useSelector(
  //   (state) => state.content.division_viewcontent
  // );
  // const product_viewcontent = useSelector(
  //   (state) => state.content.product_viewcontent
  // );
  // const productId_viewcontent = useSelector(
  //   (state) => state.content.productId_viewcontent
  // );
  // const col1_visible = useSelector((state) => state.content.col1_visible);

  const viewContentFunc = async (item) => {
    if (item.te_contenttype !== "text") {
      const resp = await fetch(item.contentUrl, options);
      const b = await resp.blob();
      const url = URL.createObjectURL(b);
      console.log({ item, resp, b, url });
      setContentPopUpSrc(url);
    } else {
      setContentPopUpSrc(item.te_contenttext);
    }

    setViewContentPopUp(true);
    setContentPopUpType(item.contentType);
    setContentPopUpFormat(item.contentFormat);
    setViewContentPopUpDetails(item);
    // setViewContentPopUp(true);

    // setContentPopUpType(item.contentType);
    // setContentPopUpFormat(item.contentFormat);
    // setViewContentPopUpDetails(item);
    // item.contentType === "text"
    //   ? setContentPopUpSrc(item.contentDescription)
    //   : setContentPopUpSrc(item.contentUrl);
  };
  const viewContentPopUpStyle = {
    position: "absolute",
    backgroundColor: "white",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "95vw",
    overflowY: "auto",
    height: "95vh",
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    p: 4,
  };

  // Dispatch function
  const dispatch = useDispatch();

  // useEffect(() => console.log({ division }))
  useEffect(() => {
    // console.log({ viewContentPopUpDetails });
  }, [viewContentPopUpDetails]);

  return (
    <>
      {contents.length === 0 ? null : (
        <div>
          {apiLoad ? (
            <div
              style={{
                height: "80vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="spinnerApi"></div>
            </div>
          ) : (
            <div
              className="accordion-item border border-secondary rounded m-2"
              style={{ backgroundColor: "white" }}
              onClick={() => setIsActive(!isActive)}
            >
              <div
                className="accordion-title"
                // onClick={() => setIsActive(!isActive)}
              >
                <div
                  className="d-flex justify-content-between"
                  // style={{ backgroundColor: "#EBEBEB" }}
                >
                  <div className="mt-2">
                    <strong
                      className="p-1 ps-2"
                      style={{ cursor: "pointer" }}
                    >{`${productName}`}</strong>
                    {/* <span className="mx-2">
                  {isActive ? (
                    <i className="bi bi-caret-down-fill"></i>
                  ) : (
                    <i className="bi bi-caret-right-fill"></i>
                  )}
                </span> */}
                  </div>
                  <div className="p-2 me-1">
                    <button
                      className="btn"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="false"
                      aria-controls="collapseOne"
                      style={{
                        backgroundColor: "var(--themes-color)",
                        color: "white",
                        minWidth: "100px",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        dispatch(contentReducer.addContent_IsPane1(true));
                        // handleReset();
                        // setFormvalues([]);
                        // setadd3DContentfiles(false);
                        // setadd3DContent(false);
                        dispatch(
                          contentReducer.division_viewcontent(divisionname)
                        );
                        dispatch(contentReducer.bu_viewcontent(buName));
                        dispatch(
                          contentReducer.product_viewcontent(productName)
                        );
                        dispatch(
                          contentReducer.productId_viewcontent(productId)
                        );

                        tableupdate(productId);
                        dispatch(contentReducer.col1_visible(true));
                      }}
                    >
                      &nbsp;
                      <span
                        className="ToolTipU"
                        style={{
                          backgroundColor: "var(--themes-color)",
                        }}
                      >
                        <i className="bi bi-view-list"></i>&nbsp; View Content
                      </span>
                    </button>
                  </div>
                </div>
              </div>

              {isActive && (
                <div
                  className="accordion-content Card-Scroll border rounded"
                  style={{
                    overflowX: "auto",
                    margin: "0 auto",
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                >
                  {contents.map((item, index) => (
                    <Card
                      onClick={(e) => {
                        viewContentFunc(item);
                        e.stopPropagation();
                      }}
                      className={`card border shadow-sm mb-3 m-2 content${
                        item.contentType === "video"
                          ? "Video"
                          : item.contentType === "image"
                          ? "Image"
                          : item.contentType === "audio"
                          ? "Audio"
                          : item.contentType === "file"
                          ? "File"
                          : item.contentType === "text"
                          ? "Text"
                          : null
                      }`}
                      style={{
                        height: "250px",
                        borderRadius: "10px",
                        maxWidth: "240px",
                        minWidth: "240px",
                        cursor: "pointer",
                        border:"2px solid #009900 !important"
                      }}
                      key={index}
                    >
                      <div
                        className="logoContent-Prod"
                        // style={{ borderRadius: "25px" }}
                      >
                        <img
                          className="p-2"
                          style={{
                            height: "50px",
                            width: "50px",
                            // borderRadius: "25px",
                          }}
                          src={
                            item.contentFormat === "png"
                              ? require("../../images/png1.png")
                              : item.contentFormat === "jpg"
                              ? require("../../images/jpg1.png")
                              : item.contentFormat === "pdf"
                              ? require("../../images/pdf1.png")
                              : item.contentFormat === "gif"
                              ? require("../../images/gif1.png")
                              : item.contentFormat === "jpeg"
                              ? require("../../images/jpeg1.png")
                              : item.contentFormat === "mp4"
                              ? require("../../images/mp41.png")
                              : item.contentFormat === null
                              ? require("../../images/txt1.png")
                              : item.contentFormat === "mp3"
                              ? require("../../images/mp31.png")
                              : item.contentFormat === "docx"
                              ? require("../../images/doc1.png")
                              : item.contentFormat === "mov"
                              ? require("../../images/mov.png")
                              : null
                          }
                          alt="C_LOGO"
                        />

                        <p
                          className="pt-1 ps-2 "
                          style={{
                            fontSize: "0.9em",
                            width: "100px",
                            fontWeight: "600",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item.contentTitle}
                        </p>
                      </div>
                      <p
                        className="ps-1 m-0"
                        style={{
                          fontSize: "0.9em",
                          width: "100px",
                          fontWeight: "300",
                          whiteSpace: "nowrap",
                        }}
                      >{`${divisionname}/${buName}`}</p>
                      {/* <p className="ps-2 mb-0">{item.contentFormat}</p> */}
                      <hr
                        className="m-0"
                        // style={{ marginTop: "2px", marginBottom: "2px" }}
                      />
                      <div className="card-body pt-2 ps-1">
                        <p
                          className="g-0 pt-0"
                          style={{
                            maxWidth: "98%",
                            maxHeight: "10px",
                            fontSize: "11px",
                            textAlign: "justify",
                            fontWeight: "500",
                          }}
                        >
                          {item.contentDescription}
                        </p>
                      </div>
                    </Card>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      )}
      <Modal
        open={viewContentPopUp}
        // open={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box style={viewContentPopUpStyle}>
          <button
            className="btn btn-danger"
            style={{
              position: "relative",
              marginTop: "10px",
              marginLeft: "96.5%",
            }}
            onClick={() => {
              setViewContentPopUp(false);
            }}
          >
            <i className="bi bi-x"></i>
          </button>
          <div className="m-2" style={{ overflowY: "auto" }}>
            {contentPopUpType === "image" && (
              <div className="border">
                <h3 className="my-2 ps-2">
                  <strong style={{ whiteSpace: "nowrap" }}>
                    {viewContentPopUpDetails.contentTitle}
                  </strong>
                </h3>
                <div className="d-flex">
                  <div className="p-2">
                    <img
                      src={contentPopUpSrc}
                      alt="IMG"
                      height="600px"
                      width="800px"
                      style={{ objectFit: "contain" }}
                    />
                  </div>
                  <div className="p-2">
                    <div className="my-4">
                      <ul className="viewContentLi">
                        <li className="my-3">{`${viewContentPopUpDetails.contentFormat} format`}</li>
                        <li className="my-3">{`${divisionname} / ${buName}`}</li>
                        <li className="my-3">
                          {viewContentPopUpDetails.contentDescription}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {contentPopUpType === "video" && (
              <div className="border">
                <h3 className="my-2 ps-2">
                  <strong style={{ whiteSpace: "nowrap" }}>
                    {viewContentPopUpDetails.contentTitle}
                  </strong>
                </h3>
                <div className="d-flex">
                  <div className="p-2">
                    <video className="border" controls width="900" height="450">
                      <source
                        src={contentPopUpSrc}
                        // type={`video/${contentPopUpFormat}`}
                      />
                      Sorry, your browser doesn't support videos.
                    </video>
                  </div>
                  <div className="p-2 ">
                    <div className="my-2">
                      <ul className="viewContentLi">
                        <li className="my-3">{`${viewContentPopUpDetails.contentFormat} format`}</li>
                        <li className="my-3">{`${divisionname} / ${buName}`}</li>
                        <li className="my-3">
                          {viewContentPopUpDetails.contentDescription}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {contentPopUpType === "audio" && (
              <div
                className="border"
                style={{
                  height: "80vh",
                  paddingLeft: "43%",
                }}
              >
                <div
                  className="ms-3"
                  style={{ paddingTop: "5%", marginBottom: "2%" }}
                >
                  <h3>
                    <strong>{viewContentPopUpDetails.contentTitle}</strong>
                  </h3>
                </div>
                <audio controls controlsList="nodownload">
                  <source
                    src={contentPopUpSrc}
                    type={`audio/${contentPopUpFormat}`}
                  />
                  Your browser does not support the audio element.
                </audio>
                <div className="my-4">
                  <ul className="viewContentLi">
                    <li className="my-3">{`${viewContentPopUpDetails.contentFormat} format`}</li>
                    <li className="my-3">{`${divisionname} / ${buName}`}</li>
                    <li className="my-3">
                      {viewContentPopUpDetails.contentDescription}
                    </li>
                  </ul>
                </div>
              </div>
            )}
            {contentPopUpType === "text" && (
              <div
                className="border p-2 shadow-sm"
                style={{ height: "300px", overflow: "auto" }}
              >
                {contentPopUpSrc}
              </div>
            )}
            {contentPopUpType === "file" &&
              (contentPopUpFormat === "pdf" ? (
                <div className="border" onContextMenu="return false">
                  <h3 className="my-3 ps-2">
                    <strong>{viewContentPopUpDetails.contentTitle}</strong>
                  </h3>
                  <div className="d-flex">
                    <div className="audio-player p-2" style={{ width: "70%" }}>
                      <embed
                        src={`${contentPopUpSrc}#toolbar=0`}
                        type={`application/${contentPopUpFormat}`}
                        style={{ height: "70vh", width: "100%" }}
                      ></embed>{" "}
                    </div>
                    <div className="p-2">
                      <div className="my-4">
                        <ul className="viewContentLi">
                          <li className="my-3">{`${viewContentPopUpDetails.contentFormat} format`}</li>
                          <li className="my-3">{`${divisionname} / ${buName}`}</li>
                          <li className="my-3">
                            {viewContentPopUpDetails.contentDescription}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              ) : contentPopUpFormat === "txt" ? (
                <embed
                  src={contentPopUpSrc}
                  type="text/plane"
                  style={{ width: "100%", height: "80vh" }}
                ></embed>
              ) : contentPopUpFormat === "doc" ? (
                <embed
                  src={contentPopUpSrc}
                  type="application/msword"
                  style={{ width: "100%", height: "80vh" }}
                ></embed>
              ) : contentPopUpFormat === "docx" ? (
                <embed
                  src={contentPopUpSrc}
                  type="application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  style={{ width: "100%", height: "80vh" }}
                ></embed>
              ) : contentPopUpFormat === "odt" ? (
                <embed
                  src={contentPopUpSrc}
                  type="application/vnd.oasis.opendocument.text"
                  style={{ width: "100%", height: "80vh" }}
                ></embed>
              ) : null)}
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default ProductAccordion;
